import type { Optional } from '@festina-life/core'
import type { FPlusViewerAlignment } from '@festina-life/fplus'
import type { FPlusLiteralType } from '@festina-life/fplus-monaco'
import cx from 'classnames'

import { expressionItemClassName } from './helpers'

type Props = {
  alignment: FPlusViewerAlignment
  item: string
  type?: Optional<FPlusLiteralType>
}

export const LiteralExpressionItem = ({ alignment, item, type }: Props) => (
  <div
    className={cx('w-full font-code text-[11px]', {
      'text-center': alignment === 'center',
      'text-left': alignment === 'left',
    })}
  >
    {item === 'null' ? (
      <div className={expressionItemClassName.null ?? ''}>{item}</div>
    ) : (
      <pre className={type ? (expressionItemClassName[type] ?? '') : ''}>
        {item}
      </pre>
    )}
  </div>
)
